// removed by extract-text-webpack-plugin
module.exports = {"title":"cLx7VQLKZlQZemKj7U_Dc","tool_list":"_3_kr39MPYzBm3lnsNnbZnf","tool":"_2xYYPf_w2TDdilzf7E6Xqe","bottom":"_1DcYe7EgbNPD9LCXPT62Nz"};


//////////////////
// WEBPACK FOOTER
// ./src/views/live/home.module.css
// module id = 830
// module chunks = 0